export const POPUP_BAR_MAX_HEIGHT = 40;
export const MOBILE_POPUP_SELECTOR_CLOSE_BUTTON_HEIGHT = 48;
